import Link from "next/link";
import { gutterCalculator } from "../../../util/utils";
import {
  viewport,
  colors,
  font,
  lineHeight,
} from "../../../styles/cssinjs/helpers/variables.js";

import MultiplePara from "../../atoms/common/MultiplePara";

const List = ({ data, classes }) => {
  return (
    <div className={`container card--default card--feature fx--tl ${classes}`}>
      {data.map((item, count) => {
        if (item.hasOwnProperty("type") && item.type === "moreInfo") {
          return (
            <Link
              className="btn-outline md:mb-0 md:mt-2.5 fx--c fx--cv fx--ch cards__moreInfo bg:hover-white lg:pb-19 lg:pt-19 gutter-space lg:mt-5 md:mt-5"
              href={`mailto:${item.href}`}
              key={count}
            >
              <p>{item.text}</p>
              <p className="lg:mt-1 md:mt-2 text-sm text-brandcolor">
                {item.href}
              </p>
              <style jsx>
                {`
                  @media (min-width: ${viewport.tablet.md}) {
                    .gutter-space {
                      margin-left: 40px;
                      margin-right: 40px;
                    }
                  }
                  @media (min-width: ${viewport.tablet
                      .sm}) and (max-width: ${viewport.tablet.md}) {
                    .gutter-space {
                      margin-left: 20px;
                      margin-right: 20px;
                    }
                  }
                `}
              </style>
            </Link>
          );
        }
        let gutterClass = gutterCalculator("gutter-space", count);
        return (
          <Link
            href={item.href}
            key={count}
            prefetch={false}
            className={`btn-outline md:mb-0 pt-3 pb-4 px-3 text-left bg:hover-white ${gutterClass} ${
              count >= 3 ? "lg:mt-5" : ""
            } ${count > 0 ? "md:mt-2.5" : ""}`}
          >
            <div className="icon-title-wrap">
              {item.hasOwnProperty("icon") && (
                <figure dangerouslySetInnerHTML={{ __html: item.icon }} />
              )}
              <h3 className="lg:mt-2 lg:mb-2 text-brandcolor">{item.title}</h3>
              {item.hasOwnProperty("dot") && (
                <span className={`animated-dot ${item.dot.color}`} />
              )}
            </div>
            <MultiplePara data={item.desc} />
            <style global jsx>
              {`
                @media (min-width: ${viewport.tablet.md}) {
                  .gutter-space {
                    margin-left: 40px;
                    margin-right: 40px;
                  }
                }
                @media (min-width: ${viewport.tablet
                    .sm}) and (max-width: ${viewport.tablet.md}) {
                  .gutter-space {
                    margin-left: 20px;
                    margin-right: 20px;
                  }
                }
              `}
            </style>
          </Link>
        );
      })}
    </div>
  );
};

export default function OutlineCards({ data, classes }) {
  return <List data={data} classes={classes} />;
}
